import React from "react";
import Table from 'react-bootstrap/Table';
import DownloadIcon from './DownloadIcon';

const getOpenApiJsonContentUrl = "/getOpenApiJsonContent/openApiJsonLink/";
const getPostmanCollectionContentUrl="/getPostmanCollectionContent/postmanCollectionLink/";

const FirstPopupRow = (props) => {
  let openApi = props.definition.openapi_json;
  let postmanCollection = props.definition.postman_collectionv2;
  let version= props.definition.update_version;
  let createdBy = props.definition.created_by;
  let createdOn = props.definition.created_on;

  let isPostmanNull = 0;
  let isOpenApiNull = 0;
  if (postmanCollection == null || postmanCollection == "") isPostmanNull = 1;
  if (openApi == null || openApi == "") isOpenApiNull = 1;
  // console.log(isOpenApiNull);
  
  return (
          <tr>
            <td className="td01">{openApi}</td>
            <td className="td01">{postmanCollection}</td>
            <td className="td02">{version}</td>
            <td className="td03">{createdBy}</td>
            <td className="td03">{createdOn}</td>
            <td className="td04">
              <DownloadIcon
                isNull={isOpenApiNull}
                url={getOpenApiJsonContentUrl+openApi}
                cssId={'OpenApiIcon'}
              />
            </td>
            <td className="td04">
              <DownloadIcon
                isNull={isPostmanNull}
                url={getPostmanCollectionContentUrl+postmanCollection}
                cssId={'PostmanIcon'}
              />
            </td>
          
          </tr>
  );
};

export default FirstPopupRow;
